export default "__VITE_ASSET__CUorrKrG__"